<!--更新采购单号-->
<template>
<div>
    <el-dialog
        :title="msg('更新采购单号')" :visible.sync="visible "
        :close-on-click-modal="false"  size="mini" width="600px"
    >
        <el-form ref="form" label-width="100px">
            <el-form-item :label="msg('采购单号：')">
                <el-input v-model="purchaseCode" @change="changePurchaseCode" :placeholder="msg('请输入采购单号')">
                    <el-button slot="append" icon="el-icon-search" @click="showSearchPurchaseCodeDialog">选择历史订单</el-button>
                </el-input>
            </el-form-item>
            <el-form-item :label="msg('采购平台：')">
                <el-select v-model="purchasePlatform" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="doUpdate()">{{msg('确定')}}</el-button>
        </span>
    </el-dialog>
    <!--选择采购单号-->
    <search-purchase-code-dialog ref="SearchPurchaseCodeDialogRef" @finish="finishSearchPurchaseCode"/>
</div>
</template>

<script>
import SearchPurchaseCodeDialog from "./SearchPurchaseCodeDialog.vue"
export default {
    name: 'UpdatePurchaseCodeDialog',
    components: {
        SearchPurchaseCodeDialog,
    },
    data(){
        return {
            visible: false,
            purchaseCode: null,
            purchasePlatform: null,
            details: null,
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ],
        }
    },
    methods: {
        showDialog(selectes){
            let user = JSON.parse(localStorage.getItem("user"));

            if(user.deptPath.indexOf('/1/6262/2') > -1){
                //圣捷下面的客户只需要有会员就可以
                if(!user.vip || user.vip == 0){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }else{
                if(!this.hasPermission("stock:detailPurchase")){
                    this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
                    return;
                }
            }
            // if(!this.hasPermission("stock:detailPurchase")){
            //     this.$message(this.msg('没有权限或非超级会员，不能进行快捷采购！'));
            //     return;
            // }

            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            this.purchaseCode = null;
            this.purchasePlatform = null;
            this.details = selectes;
            this.visible = true;
        },
        changePurchaseCode(){
            if(this.purchaseCode && !this.purchasePlatform && this.purchaseCode.indexOf("-")-1){
                this.purchasePlatform = "pdd";
            }
        },
        showSearchPurchaseCodeDialog(){
            this.$refs.SearchPurchaseCodeDialogRef.showDialog(0);
        },
        finishSearchPurchaseCode(order, rowIndex){
            this.purchaseCode = order.orderCode;
            this.purchasePlatform = 'pdd';
        },
        doUpdate(){
            let selectes = this.details
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            if(!this.purchaseCode){
                this.$message(this.msg('采购单号不存在'));
                return;
            }
            if(!this.purchasePlatform){
                this.$message(this.msg('请选择采购平台'));
                return;
            }
            let cost = 0;
            let resCost = this.purchaseCost;
            if(resCost){
                cost = (resCost*100).toFixed(0);
            }
            let para = [];
            selectes.forEach(e=>{
                para.push({
                    id:e.id,
                    stockId:e.stockId,
                    cost: cost
                })
            })
            this.$axios.post(this.$kit.api.stockDetail.updateDetailPurchaseCodes
                        +"?code="+this.purchaseCode
                        +"&u=0"
                        +"&type="+this.purchasePlatform,
                        // +"&created="+this.purchaseTime || null
                        para
            ).then((result) => {
                if(result.status){
                    this.visible = false;
                    this.$emit("finish");
                }
                this.$message(result.msg);
            });
        }
    }
}

</script>
